import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Modal } from 'react-bootstrap';


const Confirmation = function RenderConfirmationWrapper(props) {
  const { formattedMessages, formattedMessageValues, showModal, handleClose, handleSubmit } = props;

  const onClose = () => {
    handleClose();
  };

  const onSubmit = () => {
    handleSubmit();
  };

  const renderLabel = (label, labelValues) => {
    if (label && labelValues) {
      return (<FormattedMessage {...label}
        values={labelValues}
      />);
    }
    if (label) {
      return <FormattedMessage {...label} />;
    }
    return null;
  };

  return (
    <Modal show={ showModal }
      onHide={ onClose }
      backdrop="static"
      aria-labelledby="modalTitle"
    >
      <Modal.Header closeButton>
        <Modal.Title data-qa-item="modal-title">
          <div id="modalTitle" tabIndex="0">
            {
              formattedMessages && renderLabel(formattedMessages.title,
                formattedMessageValues && formattedMessageValues.title)
            }
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div id="instruction" tabIndex="0">
          {
              formattedMessages && renderLabel(formattedMessages.instruction,
                formattedMessageValues && formattedMessageValues.instruction)
          }
        </div>
      </Modal.Body>
      <Modal.Footer>
        <a role="button"
          tabIndex="0"
          className="btn btn-primary"
          data-qa-item="SubmitButton"
          onClick={onSubmit}
        >
            {
              formattedMessages && renderLabel(formattedMessages.button.submit,
                formattedMessageValues && formattedMessageValues.button ?
                  formattedMessageValues.button.submit : null)
            }
        </a>
        <a role="button"
          tabIndex="0"
          className="btn btn-outline-secondary"
          onClick={ onClose }
          data-qa-item="CancelButton"
        >
          {
            formattedMessages && renderLabel(formattedMessages.button.cancel,
              formattedMessageValues && formattedMessageValues.button ?
                formattedMessageValues.button.cancel : null)
          }
        </a>
      </Modal.Footer>
    </Modal>
  );
};

Confirmation.propTypes = {
  showModal: PropTypes.bool,
  formattedMessageValues: PropTypes.object,
  formattedMessages: PropTypes.object,
  handleClose: PropTypes.func,
  handleSubmit: PropTypes.func,
};

export default Confirmation;